import React from 'react';
import { ArrowRight } from 'lucide-react';
const RELATED = [{
  name: 'Outdoor Parcel Locker (OPL) - 2 Door',
  price: '$1,200.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=200&site=6153&user=4145&v=1&w=200',
  href: '#'
}, {
  name: 'Replacement Tenant Lock for 4C Mailboxes',
  price: '$18.50',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=200&site=6153&user=4145&v=1&w=200',
  href: '#'
}, {
  name: '16-Door Cluster Box Unit (CBU)',
  price: '$1,850.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=200&site=6153&user=4145&v=1&w=200',
  href: '#'
}, {
  name: 'Custom Engraved Number Plates',
  price: '$5.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=200&site=6153&user=4145&v=1&w=200',
  href: '#'
}];
export function RelatedProducts() {
  return <div className="mt-16 pt-12 border-t border-brand-border" data-id="element-565">
      <div className="flex items-center justify-between mb-8" data-id="element-566">
        <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-567">
          Related Products
        </h2>
        <a href="/6m8/commercial-mailboxes-lockers.html" className="hidden sm:flex items-center text-brand-green font-semibold hover:text-brand-red transition-colors" data-id="element-568">
          View all commercial <ArrowRight size={16} className="ml-2" data-id="element-569" />
        </a>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-id="element-570">
        {RELATED.map((product, idx) => <a key={idx} href={product.href} className="group bg-white rounded-xl border border-brand-border overflow-hidden hover:shadow-md hover:border-brand-green/50 transition-all flex flex-col" data-id="element-571">
            <div className="bg-brand-cream/30 aspect-square p-4 border-b border-brand-border/50 flex items-center justify-center" data-id="element-572">
              <img src={product.image} alt={product.name} className="w-full h-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-300" data-id="element-573" />
            </div>
            <div className="p-4 flex flex-col flex-grow" data-id="element-574">
              <h3 className="font-bold text-sm text-brand-charcoal group-hover:text-brand-green transition-colors mb-2 line-clamp-2" data-id="element-575">
                {product.name}
              </h3>
              <div className="text-brand-green font-bold mt-auto" data-id="element-576">
                {product.price}
              </div>
            </div>
          </a>)}
      </div>
    </div>;
}